import {CATCH_CONTEXT_MENU} from '@/constants/main';
import MyCatch from '@/components/my/common/item/MyCatch';
import {SoopUiSwiper} from '@/components/ui';
import {useHiddenStreamer} from '@/components/main/common/hooks/useHiddenStreamer';
import {getTimeStamp, isLogin} from '@/utils/main';
import useListViewLog from '@/components/main/MyPlus/hooks/useListViewLog';
import {useEffect} from 'react';
const CatchList = ({catchList, selectedMode, log = {}}) => {
  const {startObserve, endObserve} = useListViewLog(
    {
      path1: !isLogin()
        ? 'popular'
        : selectedMode === 'popular'
          ? selectedMode
          : 'myplus',
      path2: 'catch',
      listType: 'CATCH',
      selector: '.catch_area',
    },
    catchList,
  );

  /** 로그 활성화 */
  useEffect(() => {
    startObserve();
    return () => endObserve();
  }, [catchList, selectedMode]);

  const {
    hiddenStreamerList,
    handleOnClickHiddenStreamer,
    handleOnClickUndoHiddenStreamer,
  } = useHiddenStreamer('VOD', 'myplus');
  const swiperConfig = {
    loop: false,
    spaceBetween: 20,
  };

  const handleOnClickMenu = (e, type, data) => {
    if (type === 'hidden') {
      handleOnClickHiddenStreamer(data);
    }
  };

  const handleUndoBroadcast = (data) => {
    if (hiddenStreamerList.includes(data.broadcastId)) {
      handleOnClickUndoHiddenStreamer(data);
    }
  };

  return (
    <div data-testid='catch_area' className='catch_area'>
      <SoopUiSwiper
        swiperClass='catch_list'
        swiperTag='ul'
        maxSlidesPerView={10}
        otherMaxSlidesResolution={[
          {max: 1623, slidePerView: 10},
          {max: 1202, slidePerView: 8},
          {max: 1000, slidePerView: 6},
          {max: 751, slidePerView: 5},
          {max: 496, slidePerView: 4},
          {max: 0, slidePerView: 3},
        ]}
        options={swiperConfig}>
        {catchList.map((item, idx) => (
          <li key={idx}>
            <MyCatch
              {...{
                ...item,
                isAdult: Number(item.grade) === 19,
                catchContextMenuList: CATCH_CONTEXT_MENU,
              }}
              thumbnailSrc={item.thumbnailSrc ?? item.thumbH}
              isLogSendData={{listIdx: idx + 1, ...log}}
              hiddenStreamerList={hiddenStreamerList}
              handleUndoBroadcast={handleUndoBroadcast}
              handleMenuClicked={handleOnClickMenu}
            />
          </li>
        ))}
      </SoopUiSwiper>
    </div>
  );
};

export default CatchList;
